import styled from 'styled-components';
import CheckMark from 'icons/accept';

import { colors } from '../fj-styles';

interface BaseFascadeProps {
  dataTestId?: string;
  outlineOnFocus?: boolean;
}

interface IndicatorProps {
  checked?: boolean;
}

interface WrapperProps {
  disabled?: boolean;
  color?: string;
  bgColor?: string;
}

interface LabelTextProps {
  labelColor?: string;
}

// Fascades
export const BaseFascade = styled.div.attrs<BaseFascadeProps>(({ dataTestId = 'base-fascade' }) => ({
  dataTestId,
}))`
  border: 1px solid currentColor;
  display: flex;
  padding: 1px;

  input:focus + & {
    outline: ${({ outlineOnFocus }: BaseFascadeProps) =>
      outlineOnFocus ? '3px auto currentColor' : 'none'};
  }
`;

export const RadioFascade = styled(BaseFascade)`
  height: 18px;
  width: 18px;
  border-radius: 100%;
  padding: 2px;
`;

export const CheckboxFascade = styled(BaseFascade)`
  height: 16px;
  width: 16px;
  font-size: 12px;
  border-radius: 0;
  justify-content: center;
  align-items: center;
`;

export const MiniCheckboxFascade = styled(BaseFascade)`
  height: 11px;
  width: 11px;
  font-size: 7px;
  margin: 5px;
  border-radius: 0;
  justify-content: center;
  align-items: center;
`;

// Indicators
export const CheckIndicator = styled(CheckMark)<IndicatorProps>`
  transition: transform 200ms ease;
  transform: scale(${(props) => (props.checked ? 1 : 0)});
  z-index: 2;
`;

export const RadioIndicator = styled.div<IndicatorProps>`
  flex: 1;
  border-radius: 100%;
  background-color: currentColor;
  transition: transform 200ms ease;
  transform: scale(${(props) => (props.checked ? 1 : 0)});
  z-index: 2;
`;

// General
export const Wrapper = styled.div<WrapperProps>`
  cursor: default;
  display: flex;
  color: ${(props) => (props.disabled ? colors.lightGray.hex() : props.color)};

  ${BaseFascade} {
    background-color: ${(props) => (props.disabled ? colors.offWhite.hex() : props.bgColor)};
  }
`;

export const Label = styled.label`
  position: relative;
  display: flex;
  align-items: center;
`;

export const LabelText = styled.div<LabelTextProps>`
  margin-left: 6px;
  position: relative;
  color: ${({ labelColor }) => labelColor || 'inherit'};
`;

export const Input = styled.input`
  cursor: default;
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  pointer-events: none;
`;
